
import { createTheme } from '@mui/material/styles';

export const darkBg = 'rgb(23, 19, 11)';
export const darkTxt = 'rgb(235, 225, 212)';
export const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: 'rgb(231, 194, 108)',
        contrastText: 'rgb(63, 46, 0)',
      },
      secondary: {
        main: 'rgb(215, 197, 160)',
        contrastText: 'rgb(58, 47, 21)',
      },
      tertiary: {
        main: 'rgb(175, 207, 171)',
        contrastText: 'rgb(28, 54, 29)',
      },
      error: {
        main: 'rgb(255, 180, 171)',
        contrastText: 'rgb(105, 0, 5)',
      },
      background: {
        default: 'rgb(23, 19, 11)',
        paper: 'rgb(23, 19, 11)',
      },
      surface: {
        main: 'rgb(23, 19, 11)',
        variant: 'rgb(77, 70, 57)',
        dim: 'rgb(23, 19, 11)',
        bright: 'rgb(62, 57, 47)',
        container: 'rgb(35, 31, 23)',
        containerLow: 'rgb(31, 27, 19)',
        containerHigh: 'rgb(46, 41, 33)',
      },
      text: {
        primary: 'rgb(235, 225, 212)',
        secondary: 'rgb(208, 197, 180)',
        disabled: 'rgb(153, 144, 128)',
        hint: 'rgb(77, 70, 57)',
      },
    },
    typography: {
      fontFamily: 'Comfortaa, sans-serif',
    },
  });
  
export const lightBg = 'rgb(255, 248, 242)';
export const lightTxt = 'rgb(31, 27, 19)';
  export const lightTheme = createTheme({
    palette: {
      mode:'light',
      primary: {
        main: 'rgb(118, 90, 11)',
        contrastText: 'rgb(255, 255, 255)',
      },
      secondary: {
        main: 'rgb(107, 93, 63)',
        contrastText: 'rgb(255, 255, 255)',
      },
      tertiary: {
        main: 'rgb(73, 101, 72)',
        contrastText: 'rgb(255, 255, 255)',
      },
      error: {
        main: 'rgb(186, 26, 26)',
        contrastText: 'rgb(255, 255, 255)',
      },
      background: {
        default: 'rgb(255, 248, 242)',
        paper: 'rgb(255, 248, 242)',
      },
      surface: {
        main: 'rgb(255, 248, 242)',
        variant: 'rgb(236, 225, 207)',
        dim: 'rgb(226, 217, 204)',
        bright: 'rgb(255, 248, 242)',
        container: 'rgb(246, 237, 223)',
        containerLow: 'rgb(252, 242, 229)',
        containerHigh: 'rgb(240, 231, 217)',
      },
      text: {
        primary: 'rgb(31, 27, 19)',
        secondary: 'rgb(77, 70, 57)',
        disabled: 'rgb(126, 118, 103)',
        hint: 'rgb(77, 70, 57)',
      },
    },
    typography: {
      fontFamily: 'Comfortaa, sans-serif',
    },
  });